var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientR",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2575fc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6a11cb",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 50,50 L 120,50 C 140,50 150,70 150,90 L 150,150 L 100,150 L 100,100 C 100,80 80,80 80,100 L 80,150 L 50,150 Z",
    fill: "url(#gradientR)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 10,
    fill: "#2575fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 40,
    r: 10,
    fill: "#2575fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 10,
    fill: "#2575fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 160,
    r: 10,
    fill: "#2575fc"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 40,
    x2: 150,
    y2: 40,
    stroke: "#2575fc",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 50,
    x2: 160,
    y2: 150,
    stroke: "#2575fc",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 160,
    x2: 50,
    y2: 160,
    stroke: "#2575fc",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 150,
    x2: 40,
    y2: 50,
    stroke: "#2575fc",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f23c821154095f16b0165a9b60b1c59.svg";
export { ForwardRef as ReactComponent };